import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const { refresh } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const handled = useRef(false);

    useEffect(() => {
        if (handled.current) return;
        handled.current = true;
        const hash = location.hash || "";
        const sessionId = hash.replace(/^#/, "").split("&").map(p => p.split("=")).find(([k]) => k === "session_id")?.[1];
        if (!sessionId) { navigate("/", { replace: true }); return; }
        (async () => {
            try {
                await api.post("/auth/session", { session_id: sessionId });
                await refresh();
                window.history.replaceState(null, "", "/admin");
                navigate("/admin", { replace: true });
            } catch (_e) {
                navigate("/", { replace: true });
            }
        })();
    }, [location.hash, navigate, refresh]);

    return (
        <div className="min-h-[70vh] flex items-center justify-center" data-testid="auth-callback">
            <div className="font-mono text-xs uppercase tracking-widest text-stone">Establishing session…</div>
        </div>
    );
}
